var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResultsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EFEFEF",
    className: "st0",
    cx: 50,
    cy: 86.3,
    rx: 35.7,
    ry: 5.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E6E6E6",
    strokeWidth: 0.9418,
    strokeMiterlimit: 10,
    className: "st1",
    d: "M22.4,23.1c0-3.1,2.5-5.6,5.6-5.6l44,0c3.1,0,5.6,2.5,5.6,5.6L22.4,23.1L22.4,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E6E6E6",
    strokeWidth: 0.9418,
    strokeMiterlimit: 10,
    className: "st1",
    d: "M86.8,72.4c0,7.4-6.1,13.5-13.5,13.5l-46.6,0c-7.4,0-13.5-6.1-13.5-13.5l0-30c0-7.4,6.1-13.5,13.5-13.5       l46.6,0c7.4,0,13.5,6.1,13.5,13.5L86.8,72.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    className: "st2",
    d: "M22.4,23.1c0-3.1,2.5-5.6,5.6-5.6l44,0c3.1,0,5.6,2.5,5.6,5.6L22.4,23.1L22.4,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    className: "st2",
    d: "M86.8,72.4c0,7.4-6.1,13.5-13.5,13.5l-46.6,0c-7.4,0-13.5-6.1-13.5-13.5l0-30c0-7.4,6.1-13.5,13.5-13.5       l46.6,0c7.4,0,13.5,6.1,13.5,13.5L86.8,72.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E6E7E8",
    strokeWidth: 0.9418,
    strokeMiterlimit: 10,
    className: "st3",
    d: "M22.4,23.1c0-3.1,2.5-5.6,5.6-5.6l44,0c3.1,0,5.6,2.5,5.6,5.6L22.4,23.1L22.4,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E6E7E8",
    strokeWidth: 0.9418,
    strokeMiterlimit: 10,
    className: "st3",
    d: "M86.8,72.4c0,7.4-6.1,13.5-13.5,13.5l-46.6,0c-7.4,0-13.5-6.1-13.5-13.5l0-30c0-7.4,6.1-13.5,13.5-13.5       l46.6,0c7.4,0,13.5,6.1,13.5,13.5L86.8,72.4z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsIcon);
export default __webpack_public_path__ + "static/media/no_results_icon.3c48c1ef720d8bf94bf356198de47082.svg";
export { ForwardRef as ReactComponent };